export const YOUTUBE_SEARCH_DATA = [
  '무분할',
  '2분할',
  '3분할',
  '4분할',
  '5분할',
  '가슴 루틴',
  '등 루틴',
  '팔 루틴',
  '어깨 루틴',
  '하체 루틴',
  '복근 루틴',
]
